/**
 * @file edit-products.tsx
 * @module app/modules/uProcure/products/edit-product-variant/edit-products
 * @description Implements the edit products interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from "react";
import PriceDimesions from "./price-dimensions";
import TechnicalDetails from "./technical-details";
import ProductImages from "./product-images";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { success } from "../../../../../Global/toast";
import { catalogue } from "../../../../../utils/toast";
import ProductAddedSuccessfully from "../../../../modals/ProductAddedSuccessfully";
import ProductGuidelines from "../../../../modals/ProductGuidelines";
import clsx from "clsx";
import APICallService from "../../../../../api/apiCallService";
import { manageProduct, product } from "../../../../../api/apiEndPoints";
import { productJSON } from "../../../../../api/apiJSON/product";
import Loader from "../../../../../Global/loader";
import {
  CartonWithDozens,
  CartonWithPieces,
  Dozen,
  MultiLineText,
  MultiSelection,
  Piece,
  DateSelection,
  SingleLineText,
  SingleSelection,
  All_Products,
  ProductVariants,
  MasterProduct,
  ApprovedProduct,
} from "../../../../../utils/constants";
import { fileValidation } from "../../../../../Global/fileValidation";
import Method from "../../../../../utils/methods";
import Notification from "../../../../notification/notification";
import { useAuth } from "../../../auth";
// import { getKey } from "../../../../Global/history";
// import { warehouse as warehouseStoreString } from "../../../../utils/storeString";
import { useWarehouse } from "../../../../context/WarehouseContext";
const EditProduct = () => {

  const { selectedWarehouse } = useWarehouse();
  const { state }: any = useLocation();
  const { currentUser } = useAuth();
  const [sortClass, setSortClass] = useState({
    name: 1,
    position: 1,
  });
  const [modalImage, setModalImage] = useState("");
  const [categories, setCategories] = useState<any>();
  const [variants, setVariants] = useState<any>();
  const [countries, setCountries] = useState<any>();
  const [brands, setBrands] = useState<any>();
  const [technicalFields, setTechnicalFields] = useState<any>();
  const [fetchLoader, setFetchLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [removedTechnicalDetails, setRemovedTechnicalDetails] = useState([]);
  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      console.log("hii allproduct", state);
      let apiService = new APICallService(
        product.initProductVariant,
        state._id,
        "",
        "",
        "",
        "",
        state.moduleName,
        selectedWarehouse?.value
      );
      let response = await apiService.callAPI();
      let temp = { ...generalData };
      let tempValidation = { ...generalDataValidation };
      if (response.defaultItems) {
        let catTemp: any = [];
        let filterTechnical: any = [];
        let filterTechnicalValidation: any = [];
        // const result = response.variant.technicalInfo.concat(
        //   response.defaultItems.applicableTechnicalFields.filter((bo: any) =>
        //     response.variant.technicalInfo.every(
        //       (ao: any) => ao.reference != bo._id
        //     )
        //   )
        // );
        const newArr: any = [];
        // if (response.defaultItems.applicableTechnicalFields) {
        //   const result = response.variant.technicalInfo.concat(
        //     response.defaultItems.applicableTechnicalFields.filter((bo: any) =>
        //       response.variant.technicalInfo.every(
        //         (ao: any) => ao.reference != bo._id
        //       )
        //     )
        //   );
        //   result.map((techVal: any) => {
        //     let temp: any = [];
        //     let selectedTemp: any = [];
        //     if (techVal.enabled) {
        //       if (techVal.options.length) {
        //         techVal.options.map((optionsVal: any) => {
        //           temp.push({
        //             ...optionsVal,
        //             value: optionsVal.title,
        //             label: optionsVal.title,
        //           });
        //           selectedTemp.push(optionsVal._id);
        //         });
        //       }
        //       if (techVal.reference) {
        //         techVal._id = techVal.reference;
        //         delete techVal.reference;
        //       }
        //       filterTechnical.push({
        //         ...techVal,
        //         options: temp,
        //         selectedOptions: selectedTemp,
        //       });
        //       filterTechnicalValidation.push({ valid: false });
        //     }
        //   });
        // }
        if (response.defaultItems.applicableTechnicalFields) {
          response.defaultItems.applicableTechnicalFields.forEach((o: any) => {
            const matchingInfo = response.variant.technicalInfo.find(
              ({ reference }: any) => {
                return o._id === reference;
              }
            );
            if (matchingInfo && o.enabled) {
              const optionRef: any = [];
              if (matchingInfo.options.length) {
                matchingInfo.options.map((val: any) => {
                  optionRef.push(val._id);
                });
              }
              let temp: any = [];
              matchingInfo.options.map((val: any) => {
                temp.push({
                  label: val.title,
                  title: val.title,
                  value: val.title,
                  _id: val._id,
                });
              });
              matchingInfo.options = temp;
              newArr.push({
                selectedOptions: optionRef,
                answer: matchingInfo.answer || "",
                ...o,
              });
            } else {
              const applicableField =
                response.defaultItems.applicableTechnicalFields.find(
                  ({ _id }: any) => o._id === _id
                );
              if (applicableField) {
                let temp: any = [];
                applicableField.options.map((val: any) => {
                  temp.push({
                    label: val.title,
                    title: val.title,
                    value: val.title,
                    _id: val._id,
                  });
                });
                applicableField.options = temp;
                newArr.push({
                  selectedOptions: [],
                  answer: "",
                  ...applicableField,
                });
              }
            }
          });
          //  response.defaultItems.applicableTechnicalFields.forEach((o: any) => {
          //    const matchingInfo: any = response.variant.technicalInfo.find(
          //      ({ reference }: any) => {
          //        return o._id === reference;
          //      }
          //    );
          //    if (!matchingInfo) {
          //      let temp: any = [...removedTechnicalDetails];
          //      temp.push(o.name);
          //      setRemovedTechnicalDetails(temp);
          //    }
          //  });
          response.variant.technicalInfo.forEach((o: any) => {
            if (o.enabled === false) {
              // This technical detail has been detached
              let temp: any = [...removedTechnicalDetails];
              temp.push(o.name);
              setRemovedTechnicalDetails(temp);
            }
          });
        }
        if (newArr.length) {
          let defaultTemp: any = [];
          newArr.map(() => {
            defaultTemp.push({ valid: false });
          });
          tempValidation.technicalInfo = defaultTemp;
        }
        // let tempField:any=[]
        // newArr.map((val:)=>{
        // })
        temp.defaultTechnicalFields = newArr;
        temp.productTitle = response.variant.title;
        tempValidation.productTitle = false;
        temp.noneSelected = false;
        tempValidation.noneSelected = false;
        tempValidation.minimumCombinations = false;
        temp.clonedRef = response.variant._id;
        temp.techInfoSeparated = response.variant.techInfoSeparated;
        tempValidation.techInfoSeparated = false;
        let tempCombinations: any = [];
        let tempCombinationValidation: any = [];
        // tempValidation.technicalInfo = filterTechnicalValidation;
        // temp.defaultTechnicalFields = filterTechnical;
        if (response.variant.quantityTypes.length) {
          let imagesTemp: any = [];
          response.variant.media.map((val: any, index: number) => {
            imagesTemp.push({ ...val, id: index, order: index });
          });
          let combinationTemp: any = {
            title: response.variant.title,
            inventoryInfo: response.variant.inventoryInfo,

            dimensions: {
              cartoonDozens: response.variant.dozensInCarton,
              piecesDozens: response.variant.piecesInDozen,
              cartoonPieces: response.variant.piecesInCarton
                ? response.variant.piecesInCarton
                : "0",
              inventoryInfo: response.variant.inventoryInfo,
              product: [
                {
                  id: CartonWithDozens,
                  value: "Carton (Dozens inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: CartonWithPieces,
                  value: "Carton (Pieces inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: Dozen,
                  value: "Dozen (Pieces inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: Piece,
                  value: "Pieces",
                  isChecked: false,
                  isDisabled: false,
                },
              ],
              images: imagesTemp,
            },
          };
          let combinationValidationTemp: any = {
            title: false,
            dimensions: {
              cartoonDozens: false,
              piecesDozens: false,
              cartoonPieces: false,
              cartoonPrice: false,
              cartoonDiscount: false,
              cartoonDiscountPrice: false,
              cartoonDimenisionL: false,
              cartoonDimenisionW: false,
              cartoonDimenisionH: false,
              cartoonWeight: false,
              cartoonQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
              dozenPrice: false,
              dozenDiscount: false,
              dozenDiscountPrice: false,
              dozenDimenisionL: false,
              dozenDimenisionW: false,
              dozenDimenisionH: false,
              dozenWeight: false,
              dozenQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
              piecePrice: false,
              pieceDiscount: false,
              pieceDiscountPrice: false,
              pieceDimenisionL: false,
              pieceDimenisionW: false,
              pieceDimenisionH: false,
              pieceWeight: false,
              pieceQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
            },
          };
          let productTemp: any = [...combinationTemp.dimensions.product];
          let cartoonFound = false;
          let pieceFound = false;
          let dozenFound = false;
          response.variant.quantityTypes.map((quantVal: any) => {
            if (
              quantVal.type === CartonWithDozens ||
              quantVal.type === CartonWithPieces
            ) {
              cartoonFound = true;
              productTemp[0].isChecked = quantVal.type === CartonWithDozens;
              productTemp[1].isChecked = quantVal.type === CartonWithPieces;
              combinationTemp = {
                ...combinationTemp,
                dimensions: {
                  ...combinationTemp.dimensions,
                  cartoonDimenisionH: quantVal.dimensions.height,
                  cartoonDimenisionL: quantVal.dimensions.length,
                  cartoonDimenisionW: quantVal.dimensions.width,
                  cartoonWeight: quantVal.dimensions.weight,
                  cartoonPrice: quantVal.amount,
                  cartoonDiscountPrice: quantVal.discountAmt,
                  cartoonDiscount: "0",
                },
              };
              if (quantVal.discountAmtEnabled) {
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    cartoonDiscount: "0",
                  },
                };
              }
              if (quantVal.discountsByQuantities.length) {
                let discount: any = [];
                quantVal.discountsByQuantities.map((discVal: any) => {
                  discount.push({
                    min: discVal.min,
                    max: discVal.max,
                    discount: discVal.discountAmt,
                  });
                });
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    cartoonQuantities: discount,
                    cartoonDiscount: "1",
                  },
                };
              } else {
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    cartoonQuantities: [
                      {
                        min: 1,
                        max: 5,
                        discount: null,
                      },
                    ],
                  },
                };
              }
            }
            if (quantVal.type === Piece) {
              pieceFound = true;
              productTemp[3].isChecked = true;
              combinationTemp = {
                ...combinationTemp,
                dimensions: {
                  ...combinationTemp.dimensions,
                  pieceDimenisionH: quantVal.dimensions.height,
                  pieceDimenisionL: quantVal.dimensions.length,
                  pieceDimenisionW: quantVal.dimensions.width,
                  pieceWeight: quantVal.dimensions.weight,
                  piecePrice: quantVal.amount,
                  pieceDiscountPrice: quantVal.discountAmt,
                  pieceDiscount: "0",
                },
              };
              if (quantVal.discountAmtEnabled) {
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    pieceDiscount: "0",
                  },
                };
              }
              if (quantVal.discountsByQuantities.length) {
                let discount: any = [];
                quantVal.discountsByQuantities.map((discVal: any) => {
                  discount.push({
                    min: discVal.min,
                    max: discVal.max,
                    discount: discVal.discountAmt,
                  });
                });
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    pieceQuantities: discount,
                    pieceDiscount: "1",
                  },
                };
              } else {
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    pieceQuantities: [
                      {
                        min: 1,
                        max: 5,
                        discount: null,
                      },
                    ],
                  },
                };
              }
            }
            if (quantVal.type === Dozen) {
              dozenFound = true;
              productTemp[2].isChecked = true;
              combinationTemp = {
                ...combinationTemp,
                dimensions: {
                  ...combinationTemp.dimensions,
                  dozenDimenisionH: quantVal.dimensions.height,
                  dozenDimenisionL: quantVal.dimensions.length,
                  dozenDimenisionW: quantVal.dimensions.width,
                  dozenWeight: quantVal.dimensions.weight,
                  dozenPrice: quantVal.amount,
                  dozenDiscountPrice: quantVal.discountAmt,
                  dozenDiscount: "0",
                },
              };
              if (quantVal.discountAmtEnabled) {
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    dozenDiscount: "0",
                  },
                };
              }
              if (quantVal.discountsByQuantities.length) {
                let discount: any = [];
                quantVal.discountsByQuantities.map((discVal: any) => {
                  discount.push({
                    min: discVal.min,
                    max: discVal.max,
                    discount: discVal.discountAmt,
                  });
                });
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    dozenQuantities: discount,
                    dozenDiscount: "1",
                  },
                };
              } else {
                combinationTemp = {
                  ...combinationTemp,
                  dimensions: {
                    ...combinationTemp.dimensions,
                    dozenQuantities: [
                      {
                        min: 1,
                        max: 5,
                        discount: null,
                      },
                    ],
                  },
                };
              }
            }
          });
          // Reset values for types not encountered
          if (!cartoonFound) {
            productTemp[0].isChecked = false;
            productTemp[1].isChecked = false;
            combinationTemp = {
              ...combinationTemp,
              dimensions: {
                ...combinationTemp.dimensions,
                cartoonDimenisionH: "",
                cartoonDimenisionL: "",
                cartoonDimenisionW: "",
                cartoonWeight: "",
                cartoonPrice: "",
                cartoonDiscountPrice: "",
                cartoonDiscount: "0",
                cartoonQuantities: [
                  {
                    min: 1,
                    max: 5,
                    discount: 0,
                  },
                ],
              },
            };
          }
          if (!pieceFound) {
            productTemp[3].isChecked = false;
            combinationTemp = {
              ...combinationTemp,
              dimensions: {
                ...combinationTemp.dimensions,
                pieceDimenisionH: "",
                pieceDimenisionL: "",
                pieceDimenisionW: "",
                pieceWeight: "",
                piecePrice: "",
                pieceDiscountPrice: "",
                pieceDiscount: "0",
                pieceQuantities: [
                  {
                    min: 1,
                    max: 5,
                    discount: 0,
                  },
                ],
              },
            };
          }
          if (!dozenFound) {
            productTemp[2].isChecked = false;
            combinationTemp = {
              ...combinationTemp,
              dimensions: {
                ...combinationTemp.dimensions,
                dozenDimenisionH: "",
                dozenDimenisionL: "",
                dozenDimenisionW: "",
                dozenWeight: "",
                dozenPrice: "",
                dozenDiscountPrice: "",
                dozenDiscount: "0",
                dozenQuantities: [
                  {
                    min: 1,
                    max: 5,
                    discount: 0,
                  },
                ],
              },
            };
          }
          combinationTemp = {
            ...combinationTemp,
            dimensions: {
              ...combinationTemp.dimensions,
              product: productTemp,
            },
          };
          temp.isDraft = response.variant.draft;
          temp.combinations = [combinationTemp];
          tempValidation.combinations = [combinationValidationTemp];
        } else {
          let combinationTemp: any = {};
          let combinationValidationTemp: any = {
            title: false,
            dimensions: {
              cartoonDozens: false,
              piecesDozens: false,
              cartoonPieces: false,
              cartoonPrice: false,
              cartoonDiscount: false,
              cartoonDiscountPrice: false,
              cartoonDimenisionL: false,
              cartoonDimenisionW: false,
              cartoonDimenisionH: false,
              cartoonWeight: false,
              cartoonQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
              dozenPrice: false,
              dozenDiscount: false,
              dozenDiscountPrice: false,
              dozenDimenisionL: false,
              dozenDimenisionW: false,
              dozenDimenisionH: false,
              dozenWeight: false,
              dozenQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
              piecePrice: false,
              pieceDiscount: false,
              pieceDiscountPrice: false,
              pieceDimenisionL: false,
              pieceDimenisionW: false,
              pieceDimenisionH: false,
              pieceWeight: false,
              pieceQuantities: [
                {
                  min: false,
                  max: false,
                  discount: false,
                },
              ],
            },
          };
          combinationTemp = {
            title: "",
            dimensions: {
              cartoonDozens: "0",
              piecesDozens: "0",
              cartoonPieces: "0",
              cartoonPrice: null,
              cartoonDiscount: "0",
              cartoonDiscountPrice: null,
              cartoonDimenisionL: null,
              cartoonDimenisionW: null,
              cartoonDimenisionH: null,
              cartoonWeight: null,
              cartoonQuantities: [
                {
                  min: 1,
                  max: 5,
                  discount: null,
                },
              ],
              dozenPrice: null,
              dozenDiscount: "0",
              dozenDiscountPrice: null,
              dozenDimenisionL: null,
              dozenDimenisionW: null,
              dozenDimenisionH: null,
              dozenWeight: null,
              dozenQuantities: [
                {
                  min: 1,
                  max: 5,
                  discount: null,
                },
              ],
              piecePrice: null,
              pieceDiscount: "0",
              pieceDiscountPrice: null,
              pieceDimenisionL: null,
              pieceDimenisionW: null,
              pieceDimenisionH: null,
              pieceWeight: null,
              pieceQuantities: [
                {
                  min: 1,
                  max: 5,
                  discount: null,
                },
              ],
              product: [
                {
                  id: CartonWithDozens,
                  value: "Carton (Dozens inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: CartonWithPieces,
                  value: "Carton (Pieces inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: Dozen,
                  value: "Dozen (Pieces inside)",
                  isChecked: false,
                  isDisabled: false,
                },
                {
                  id: Piece,
                  value: "Pieces",
                  isChecked: false,
                  isDisabled: false,
                },
              ],
              selectedCartoonId: "",
              selectedDozenId: "",
              selectedPiecesId: "",
              isOpen: false,
              images: [],
              imageReader: [],
            },
          };
          tempCombinations.push(combinationTemp);
          tempCombinationValidation.push(combinationValidationTemp);
          temp.isDraft = response.product.draft;
          temp.combinations = tempCombinations;
          tempValidation.combinations = tempCombinationValidation;
        }
        setGeneralDataValidation(tempValidation);
        setGeneralData(temp);
        setInitData(JSON.parse(JSON.stringify(temp)));
        setTechnicalFields(response.defaultItems.applicableTechnicalFields);
        setCurrentTab({
          name: "Price & dimensions",
          content: (
            <PriceDimesions
              onGeneralDataChange={onGeneralDataChange}
              generalData={temp}
              validations={tempValidation}
              onValidationChange={onValidationChange}
              priceValidation={priceValidation}
            />
          ),
          value: 1,
        });
      }
      setFetchLoader(false);
    })();
    // setDisabled(true);
  }, []);
  const navigate = useNavigate();
  const [tab, setTab] = useState([
    { name: "Price & dimensions", content: <PriceDimesions />, value: 1 },
    { name: "Technical details", content: <TechnicalDetails />, value: 2 },
    { name: "Product images", content: <ProductImages />, value: 3 },
  ]);
  const [disabled, setDisabled] = useState(false);
  const [initData, setInitData] = useState<any>({
    noneSelected: false,
    productName: "",
    isDraft: false,
    combinations: [
      {
        title: "",
        dimensions: {
          cartoonDozens: "0",
          piecesDozens: "0",
          cartoonPieces: "0",
          cartoonPrice: null,
          cartoonDiscount: "0",
          cartoonDiscountPrice: null,
          cartoonDimenisionL: null,
          cartoonDimenisionW: null,
          cartoonDimenisionH: null,
          cartoonWeight: null,
          cartoonQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          dozenPrice: null,
          dozenDiscount: "0",
          dozenDiscountPrice: null,
          dozenDimenisionL: null,
          dozenDimenisionW: null,
          dozenDimenisionH: null,
          dozenWeight: null,
          dozenQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          piecePrice: null,
          pieceDiscount: "0",
          pieceDiscountPrice: null,
          pieceDimenisionL: null,
          pieceDimenisionW: null,
          pieceDimenisionH: null,
          pieceWeight: null,
          pieceQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          product: [
            {
              id: CartonWithDozens,
              value: "Carton (Dozens inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: CartonWithPieces,
              value: "Carton (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: Dozen,
              value: "Dozen (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            { id: Piece, value: "Pieces", isChecked: false, isDisabled: false },
          ],
          selectedCartoonId: "",
          selectedDozenId: "",
          selectedPiecesId: "",
          isOpen: false,
          images: [],
          imageReader: [],
        },
      },
    ],
  });
  const [generalData, setGeneralData] = useState<any>({
    noneSelected: false,
    productName: "",
    isDraft: false,
    combinations: [
      {
        title: "",
        dimensions: {
          cartoonDozens: "0",
          piecesDozens: "0",
          cartoonPieces: "0",
          cartoonPrice: null,
          cartoonDiscount: "0",
          cartoonDiscountPrice: null,
          cartoonDimenisionL: null,
          cartoonDimenisionW: null,
          cartoonDimenisionH: null,
          cartoonWeight: null,
          cartoonQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          dozenPrice: null,
          dozenDiscount: "0",
          dozenDiscountPrice: null,
          dozenDimenisionL: null,
          dozenDimenisionW: null,
          dozenDimenisionH: null,
          dozenWeight: null,
          dozenQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          piecePrice: null,
          pieceDiscount: "0",
          pieceDiscountPrice: null,
          pieceDimenisionL: null,
          pieceDimenisionW: null,
          pieceDimenisionH: null,
          pieceWeight: null,
          pieceQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          product: [
            {
              id: CartonWithDozens,
              value: "Carton (Dozens inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: CartonWithPieces,
              value: "Carton (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: Dozen,
              value: "Dozen (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            { id: Piece, value: "Pieces", isChecked: false, isDisabled: false },
          ],
          selectedCartoonId: "",
          selectedDozenId: "",
          selectedPiecesId: "",
          isOpen: false,
          images: [],
          imageReader: [],
        },
      },
    ],
  });
  const [generalDataValidation, setGeneralDataValidation] = useState<any>({
    noneSelected: false,
    productName: false,
    isDraft: false,
    minimumCombinations: false,
    combinations: [
      {
        title: false,
        dimensions: {
          cartoonDozens: false,
          piecesDozens: false,
          cartoonPieces: false,
          cartoonPrice: false,
          cartoonDiscount: false,
          cartoonDiscountPrice: false,
          cartoonDimenisionL: false,
          cartoonDimenisionW: false,
          cartoonDimenisionH: false,
          cartoonWeight: false,
          cartoonQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          dozenPrice: false,
          dozenDiscount: false,
          dozenDiscountPrice: false,
          dozenDimenisionL: false,
          dozenDimenisionW: false,
          dozenDimenisionH: false,
          dozenWeight: false,
          dozenQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          piecePrice: false,
          pieceDiscount: false,
          pieceDiscountPrice: false,
          pieceDimenisionL: false,
          pieceDimenisionW: false,
          pieceDimenisionH: false,
          pieceWeight: false,
          pieceQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
        },
      },
    ],
  });
  const [priceValidation, setPriceValidation] = useState(false);
  const onGeneralDataChange = (data: any) => {
    setGeneralData(data);
  };
  const onValidationChange = (data: any) => {
    setGeneralDataValidation(data);
  };
  const [imageString, setImageString] = useState();
  const [productAsDraftmodalShow, setProductAsDraftModalShow] = useState(false);
  const [productAddedmodalShow, setProductAddedModalShow] = useState(false);
  const [productGuidelinesmodalShow, setProductGuidelinesModalShow] =
    useState(false);
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <Link
            to={"/"}
            className={clsx(
              "nav-link  text-active-dark",
              current.name === tab.name ? "active" : " ",
              currentTab.value !== tab.value
                ? disabled
                  ? "disabled"
                  : ""
                : "",
              loading ? "disabled" : ""
            )}
            data-bs-toggle="tab"
            onClick={() => handleSelectTab(tab)}
          >
            {tab.name}
          </Link>
        </li>
      );
    });
    return allTabs;
  };
  const handleSelectTab = async (tab: any) => {
    let generalTemp = JSON.parse(JSON.stringify({ ...generalData }));
    if (tab.value === 2) {
      let priceDimensionTabValidations = await checkPriceDimensionTabValidation(
        generalTemp
      );
      if (!priceDimensionTabValidations) {
        setGeneralData(generalTemp);
        setGeneralDataValidation(generalDataValidation);
        setNavTab(tab.value, generalTemp, generalDataValidation);
      }
    } else if (tab.value === 3) {
      let technicalTabValidations = await checkTechnicalDetailsValiadtions(
        generalTemp
      );
      let validations = JSON.parse(
        JSON.stringify({ ...generalDataValidation })
      );
      if (!technicalTabValidations) {
        if (
          generalTemp.defaultTechnicalFields &&
          generalTemp.defaultTechnicalFields.length
        ) {
          generalTemp.defaultTechnicalFields.map(
            (techVal: any, techIndex: number) => {
              if (
                techVal.type === SingleLineText ||
                techVal.type === MultiLineText ||
                techVal.type === DateSelection
              ) {
                if (
                  techVal.answer === undefined ||
                  techVal.answer === null ||
                  techVal.answer === ""
                ) {
                  validations.technicalInfo[techIndex]["valid"] = true;
                }
                // form.append("technicalInfo["+techIndex+"][answer]",techVal.answer);
              }
              if (
                techVal.type === MultiSelection ||
                techVal.type === SingleSelection
              ) {
                if (
                  techVal.selectedOptions === undefined ||
                  techVal.selectedOptions === null ||
                  techVal.selectedOptions.length === 0
                ) {
                  validations.technicalInfo[techIndex]["valid"] = true;
                }
              }
            }
          );
        }
        setNavTab(tab.value, generalTemp, generalDataValidation);
      }
    } else {
      setNavTab(tab.value, generalTemp, generalDataValidation);
    }
  };
  const checkGeneralTabValidation = async (generalDataTemp: any) => {
    let generalValidationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    let valid = [];
    if (generalDataTemp.primaryCategory === "") {
      generalValidationTemp.primaryCategory = true;
      valid.push(true);
    }
    if (generalDataTemp.subCategory === "") {
      generalValidationTemp.subCategory = true;
      valid.push(true);
    }
    if (generalDataTemp.productTitle === "") {
      valid.push(true);
      generalValidationTemp.productTitle = true;
    }
    if (generalDataTemp.country === "") {
      generalValidationTemp.country = true;
      valid.push(true);
    }
    if (generalDataTemp.brand === "") {
      valid.push(true);
      generalValidationTemp.brand = true;
    }
    if (generalDataTemp.description === "") {
      valid.push(true);
      generalValidationTemp.description = true;
    }
    let selectedVariant: any = [];
    let data: any = [];
    let validations = JSON.parse(JSON.stringify({ ...generalDataValidation }));
    generalDataTemp.variants.map((variantVal: any) => {
      if (variantVal.isSelected === true) {
        let temp: any = [];
        variantVal.categories[0].options.map((optionVal: any) => {
          temp.push({ title: optionVal.title, _id: variantVal._id });
        });
        selectedVariant.push({
          options: variantVal.categories[0].options,
          _id: variantVal._id,
        });
        validations.selectedVariants.push(false);
        data.push(temp);
      }
    });
    if (!generalDataTemp.noneSelected) {
      if (selectedVariant.length) {
        let selectValTemp: any = [];
        selectedVariant.map((selectVal: any) => {
          if (selectVal.options.length) {
            selectValTemp.push(false);
          } else {
            valid.push(true);
            selectValTemp.push(true);
          }
        });
        generalValidationTemp.selectedVariants = selectValTemp;
      } else {
        valid.push(true);
        generalValidationTemp.variants = true;
      }
    } else {
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el) => {
      return el === true;
    });
    return validationResult;
  };
  const checkPriceDimensionTabValidation = async (generalDataTemp: any) => {
    let generalValidationTemp = { ...generalDataValidation };
    let valid = [];
    if (generalDataTemp.combinations.length) {
      let allTrue = generalDataTemp.combinations.some(({ dimensions }: any) =>
        dimensions.product.some(({ isChecked }: any) => isChecked === true)
      );
      generalDataTemp.combinations.map(({ dimensions }: any, index: number) => {
        generalDataValidation.combinations[index].validation =
          !dimensions.product.some(({ isChecked }: any) => isChecked === true);
      });
      if (!allTrue) {
        valid.push(true);
        generalDataValidation.minimumCombinations = true;
      } else {
        generalDataValidation.minimumCombinations = false;
        generalDataTemp.combinations.map((combVal: any, index: number) => {
          let combinationValidation: any = [];
          if (combVal.dimensions.product[0].isChecked) {
            if (
              !combVal.dimensions.cartoonDozens ||
              combVal.dimensions.cartoonDozens === "" ||
              combVal.dimensions.cartoonDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDozens = true;
            }
            if (
              !combVal.dimensions.piecesDozens ||
              combVal.dimensions.piecesDozens === "" ||
              combVal.dimensions.piecesDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.piecesDozens = true;
            }
          }
          if (combVal.dimensions.product[2].isChecked) {
            if (
              !combVal.dimensions.piecesDozens ||
              combVal.dimensions.piecesDozens === "" ||
              combVal.dimensions.piecesDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.piecesDozens = true;
            }
          }
          if (combVal.dimensions.product[1].isChecked) {
            if (
              !combVal.dimensions.cartoonPieces ||
              combVal.dimensions.cartoonPieces === "" ||
              combVal.dimensions.cartoonPieces == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonPieces = true;
            }
          }
          if (
            combVal.dimensions.product[0].isChecked ||
            combVal.dimensions.product[1].isChecked
          ) {
            if (
              !combVal.dimensions.cartoonPrice ||
              combVal.dimensions.cartoonPrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonPrice = true;
            }
            if (combVal.dimensions.cartoonDiscount === "0") {
              if (
                combVal.dimensions.cartoonDiscountPrice &&
                combVal.dimensions.cartoonDiscountPrice !== "" &&
                combVal.dimensions.cartoonPrice &&
                combVal.dimensions.cartoonPrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.cartoonDiscountPrice) >
                  parseInt(combVal.dimensions.cartoonPrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.cartoonDiscountPrice = true;
                }
              }
            } else {
              if (combVal.dimensions.cartoonQuantities.length) {
              }
            }
            if (
              !combVal.dimensions.cartoonDimenisionL ||
              combVal.dimensions.cartoonDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionL = true;
            }
            if (
              !combVal.dimensions.cartoonDimenisionW ||
              combVal.dimensions.cartoonDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionW = true;
            }
            if (
              !combVal.dimensions.cartoonDimenisionH ||
              combVal.dimensions.cartoonDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionH = true;
            }
            if (
              !combVal.dimensions.cartoonWeight ||
              combVal.dimensions.cartoonWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonWeight = true;
            }
          }
          if (combVal.dimensions.product[2].isChecked) {
            if (
              !combVal.dimensions.dozenPrice ||
              combVal.dimensions.dozenPrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.dozenPrice =
                true;
            }
            if (combVal.dimensions.dozenDiscount === "0") {
              if (
                combVal.dimensions.dozenDiscountPrice &&
                combVal.dimensions.dozenDiscountPrice !== "" &&
                combVal.dimensions.dozenPrice &&
                combVal.dimensions.dozenPrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.dozenDiscountPrice) >
                  parseInt(combVal.dimensions.dozenPrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.dozenDiscountPrice = true;
                }
              }
            }
            if (
              !combVal.dimensions.dozenDimenisionL ||
              combVal.dimensions.dozenDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionL = true;
            }
            if (
              !combVal.dimensions.dozenDimenisionW ||
              combVal.dimensions.dozenDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionW = true;
            }
            if (
              !combVal.dimensions.dozenDimenisionH ||
              combVal.dimensions.dozenDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionH = true;
            }
            if (
              !combVal.dimensions.dozenWeight ||
              combVal.dimensions.dozenWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.dozenWeight =
                true;
            }
          }
          if (combVal.dimensions.product[3].isChecked) {
            if (
              !combVal.dimensions.piecePrice ||
              combVal.dimensions.piecePrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.piecePrice =
                true;
            }
            if (combVal.dimensions.pieceDiscount === "0") {
              if (
                combVal.dimensions.pieceDiscountPrice &&
                combVal.dimensions.pieceDiscountPrice !== "" &&
                combVal.dimensions.piecePrice &&
                combVal.dimensions.piecePrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.pieceDiscountPrice) >
                  parseInt(combVal.dimensions.piecePrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.pieceDiscountPrice = true;
                }
              }
            }
            if (
              !combVal.dimensions.pieceDimenisionL ||
              combVal.dimensions.pieceDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionL = true;
            }
            if (
              !combVal.dimensions.pieceDimenisionW ||
              combVal.dimensions.pieceDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionW = true;
            }
            if (
              !combVal.dimensions.pieceDimenisionH ||
              combVal.dimensions.pieceDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionH = true;
            }
            if (
              !combVal.dimensions.pieceWeight ||
              combVal.dimensions.pieceWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.pieceWeight =
                true;
            }
          }
          let result = combinationValidation.some((el: any) => {
            return el === true;
          });
          generalValidationTemp.combinations[index].validation = result;
        });
      }
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el) => {
      return el === true;
    });
    return validationResult;
  };
  const checkTechnicalDetailsValiadtions = async (generalDataTemp: any) => {
    let generalValidationTemp = { ...generalDataValidation };
    let valid: any = [];
    if (
      generalDataTemp.defaultTechnicalFields &&
      generalDataTemp.defaultTechnicalFields.length
    ) {
      generalDataTemp.defaultTechnicalFields.map(
        (techVal: any, techIndex: number) => {
          if (
            techVal.type === SingleLineText ||
            techVal.type === MultiLineText ||
            techVal.type === DateSelection
          ) {
            if (techVal.type === DateSelection) {
              if (
                techVal.answer === undefined ||
                techVal.answer === null ||
                techVal.answer === ""
              ) {
                techVal.answer = Method.currentLocalDateTime();
              }
            } else {
              if (
                techVal.answer === undefined ||
                techVal.answer === null ||
                techVal.answer === ""
              ) {
                valid.push(true);
                generalDataValidation.technicalInfo[techIndex]["valid"] = true;
              }
            }
            // form.append("technicalInfo["+techIndex+"][answer]",techVal.answer);
          } else {
            if (
              techVal.selectedOptions === undefined ||
              techVal.selectedOptions === null ||
              techVal.selectedOptions.length === 0
            ) {
              valid.push(true);
              generalDataValidation.technicalInfo[techIndex]["valid"] = true;
            }
          }
        }
      );
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el: any) => {
      return el === true;
    });
    return validationResult;
  };
  const handlePreviousSelectTab = async (tab: any) => {
    setNavTab(tab.value, generalData, generalDataValidation);
  };
  const handleImage = async (event: any, index: number) => {
    const selectedFiles = event.target.files;
    let temp = { ...generalData };
    if (!selectedFiles) return;
    else {
      let temp2 = JSON.parse(JSON.stringify(temp));
      let generalValidationTemp = JSON.parse(
        JSON.stringify({ ...generalDataValidation })
      );
      let imageTemp: any = [];
      for (let i = 0; i < selectedFiles.length; i++) {
        if (fileValidation(selectedFiles?.[i])) {
          await toBase64(selectedFiles?.[i]).then((data) => {
            temp2.combinations[index].dimensions.images.push({
              url: URL.createObjectURL(selectedFiles?.[i]),
              obj: data,
            });
          });
        }
      }
      await setGeneralData(temp2);
      generalValidationTemp.combinations[index].dimensions.images = false;
      await setGeneralDataValidation(generalValidationTemp);
    }
  };
  const toBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleRemoveImage = (index: number, productIndex: number) => {
    let temp = { ...generalData };
    let generalValidationTemp = { ...generalDataValidation };
    let data = temp.combinations[index];
    let updatedImage = data.dimensions.images.filter(
      (e: any, i: number) => i !== productIndex
    );
    if (data.dimensions.imageReader) {
      let updatedImageReader = data.dimensions.imageReader.filter(
        (e: any, i: number) => i !== productIndex
      );
      data.dimensions.imageReader = updatedImageReader;
    }
    if (!updatedImage.length) {
      generalValidationTemp.combinations[index].dimensions.images = true;
    }
    data.dimensions.images = updatedImage;
    setGeneralDataValidation(generalValidationTemp);
    setGeneralData(temp);
  };
  const handleSubmit = async () => {
    let temp: any = { ...generalData };
    let generalValidationTemp = { ...generalDataValidation };
    let valid: any = [];
    temp.combinations.map((combVal: any, index: number) => {
      if (
        combVal.dimensions.product[0].isChecked ||
        combVal.dimensions.product[1].isChecked ||
        combVal.dimensions.product[2].isChecked ||
        combVal.dimensions.product[3].isChecked
      ) {
        if (!combVal.dimensions.images.length) {
          generalValidationTemp.combinations[index].dimensions.images = true;
          valid.push(true);
        }
      }
    });
    setGeneralDataValidation(generalValidationTemp);
    let checked = valid.some((el: any) => {
      return el === true;
    });
    if (!checked) {
      setLoading(true);
      let updatedObject: any = {
        productTitle: temp.productTitle.replace(/\s*\)\s*/g, ")"),
        isDraft: false,
      };
      if (temp.combinations.length) {
        let combinationTemp: any = [];
        temp.combinations.map((combVal: any, combIndex: number) => {
          let innerTemp: any = {
            piecesDozens: combVal.dimensions.piecesDozens,
            cartoonDozens: combVal.dimensions.cartoonDozens,
            cartoonPieces: combVal.dimensions.cartoonPieces,
          };
          if (
            combVal.dimensions.product[0].isChecked ||
            combVal.dimensions.product[1].isChecked
          ) {
            innerTemp = {
              ...innerTemp,
              cartonWithDozens: combVal.dimensions.product[0].isChecked,
              cartonWithPieces: combVal.dimensions.product[1].isChecked,
              cartoonPrice: combVal.dimensions.cartoonPrice,
              cartoonDiscount: combVal.dimensions.cartoonDiscount,
              cartoonDiscountPrice: combVal.dimensions.cartoonDiscountPrice,
              cartoonDimenisionL: combVal.dimensions.cartoonDimenisionL,
              cartoonDimenisionW: combVal.dimensions.cartoonDimenisionW,
              cartoonDimenisionH: combVal.dimensions.cartoonDimenisionH,
              cartoonWeight: combVal.dimensions.cartoonWeight,
              cartoonQuantities: combVal.dimensions.cartoonQuantities,
            };
          }
          if (combVal.dimensions.product[2].isChecked) {
            innerTemp = {
              ...innerTemp,
              dozenChecked: true,
              dozenPrice: combVal.dimensions.dozenPrice,
              dozenDiscount: combVal.dimensions.dozenDiscount,
              dozenDiscountPrice: combVal.dimensions.dozenDiscountPrice,
              dozenDimenisionL: combVal.dimensions.dozenDimenisionL,
              dozenDimenisionW: combVal.dimensions.dozenDimenisionW,
              dozenDimenisionH: combVal.dimensions.dozenDimenisionH,
              dozenWeight: combVal.dimensions.dozenWeight,
              dozenQuantities: combVal.dimensions.dozenQuantities,
            };
          }
          if (combVal.dimensions.product[3].isChecked) {
            innerTemp = {
              ...innerTemp,
              pieceChecked: true,
              piecePrice: combVal.dimensions.piecePrice,
              pieceDiscount: combVal.dimensions.pieceDiscount,
              pieceDiscountPrice: combVal.dimensions.pieceDiscountPrice,
              pieceDimenisionL: combVal.dimensions.pieceDimenisionL,
              pieceDimenisionW: combVal.dimensions.pieceDimenisionW,
              pieceDimenisionH: combVal.dimensions.pieceDimenisionH,
              pieceWeight: combVal.dimensions.pieceWeight,
              pieceQuantities: combVal.dimensions.pieceQuantities,
            };
          }
          if (Object.keys(innerTemp).length) {
            innerTemp = {
              ...innerTemp,
              images: combVal.dimensions.images,
              imageReader: combVal.dimensions.imageReader,
            };
            combinationTemp.push(innerTemp);
          }
        });
        updatedObject = { ...updatedObject, combinations: combinationTemp };
      }
      if (temp.defaultTechnicalFields && temp.defaultTechnicalFields.length) {
        temp.defaultTechnicalFields.map((val: any) => {
          if (val.type === DateSelection) {
            if (
              val.answer === undefined ||
              val.answer === "undefined" ||
              val.answer === ""
            ) {
              val.answer = new Date();
            }
          }
        });
        updatedObject = {
          ...updatedObject,
          defaultTechnicalFields: temp.defaultTechnicalFields,
          techInfoSeparated: temp.techInfoSeparated,
        };
      }
      // let modalImageTemp = updatedObject.combinations[0].images[0].url;
      // setModalImage(modalImageTemp);
      console.log("hii", state.moduleName);
      let apiService = new APICallService(
        product.editProductVariant,
        productJSON.editProductVariant({ product: updatedObject }),
        {
          id: state._id,
        },
        "",
        "",
        "",
        state.moduleName,
        selectedWarehouse?.value
      );
      let response = await apiService.callAPI();
      if (response) {
        const data = Method.compareCombination(
          initData.combinations,
          generalData.combinations
        );
        const technicalChanges = compareTechnicalFields(
          initData.defaultTechnicalFields,
          generalData.defaultTechnicalFields
        );
        if (data.length || technicalChanges.length) {

        }
        // navigate('/products/master-products ');
        if (state.isInventory) {
          let apiService = new APICallService(
            manageProduct.updateVariantStatus,
            {
              status: ApprovedProduct,
            },
            { id: state._id },
            "",
            "",
            "",
            state.moduleName,
            selectedWarehouse?.value
          );
          let response2 = await apiService.callAPI();
          if (response2) {
            window.history.back();
            success(catalogue.variantUpdated);
          }
        } else {
          window.history.back();
          success(catalogue.variantUpdated);
        }
      }
      setLoading(false);
    }
    // setProductAddedModalShow(true);
  };
  console.log("initData", initData);
  console.log("generalData", generalData);
  const combine = ([head, ...[headTail, ...tailTail]]: any): any => {
    if (!headTail) return head;
    const combined = headTail.reduce((acc: any, x: any) => {
      return acc.concat(
        head.map((h: any) => {
          let data = {
            title: `${h.title},${x.title}`,
            _id: `${h._id}-${x._id}`,
          };
          return data;
        })
      );
    }, []);
    return combine([combined, ...tailTail]);
  };
  const setNavTab = (value: any, data?: any, validations?: any) => {
    let tabTemp = [...tab];
    let currentTab = {};
    switch (value) {
      case 3:
        currentTab = {
          name: "Product images",
          content: (
            <ProductImages
              generalData={data}
              handleImage={(event: any, index: any) => {
                handleImage(event, index);
              }}
              handleRemoveImage={handleRemoveImage}
              validations={validations}
              onValidationChange={onValidationChange}
              loading={loading}
              onGeneralDataChange={onGeneralDataChange}
            />
          ),
          value: 3,
        };
        break;
      case 2:
        currentTab = {
          name: "Technical details",
          content: (
            <TechnicalDetails
              onGeneralDataChange={onGeneralDataChange}
              generalData={data}
              initData={initData}
              validations={validations}
              onValidationChange={onValidationChange}
            />
          ),
          value: 2,
        };
        break;
      case 1:
        currentTab = {
          name: "Price & dimensions",
          content: (
            <PriceDimesions
              onGeneralDataChange={onGeneralDataChange}
              generalData={data}
              validations={validations}
              onValidationChange={onValidationChange}
              priceValidation={priceValidation}
            />
          ),
          value: 1,
        };
        break;
      default:
        break;
    }
    setCurrentTab(currentTab);
    setTab(tabTemp);
  };
  const [currentTab, setCurrentTab] = useState<any>({
    name: "Price & dimensions",
    content: (
      <PriceDimesions
        onGeneralDataChange={onGeneralDataChange}
        generalData={generalData}
        validations={generalDataValidation}
        onValidationChange={onValidationChange}
        priceValidation={priceValidation}
      />
    ),
    value: 1,
  });
  useEffect(() => {
    setNavTab(currentTab.value, generalData, generalDataValidation);
  }, [generalData]);
  useEffect(() => {
    setNavTab(currentTab.value, generalData, generalDataValidation);
  }, [generalDataValidation]);
  const compareTechnicalFields = (oldData: any, newData: any) => {
    const changes: any = [];
    newData.forEach((item: any, index: number) => {
      let oldItem = oldData[index];
      if (oldItem) {
        if (JSON.stringify(oldItem) !== JSON.stringify(item)) {
          changes.push(item);
        }
      } else {
        changes.push(item);
      }
    });
    return changes;
  };
  return (
    <>
      <ProductAddedSuccessfully
        show={productAddedmodalShow}
        onHide={() => {
          setProductAddedModalShow(false);
        }}
        modalImage={modalImage}
        onSaveAsDraft={() => {
          // navigate('/products/master-products');
          window.history.back();
          setProductAddedModalShow(false);
          // success(catalogue.added);
        }}
      />
      {currentTab.value === 3 ? (
        <ProductGuidelines
          show={productGuidelinesmodalShow}
          onHide={() => setProductGuidelinesModalShow(false)}
        />
      ) : (
        <></>
      )}
      {removedTechnicalDetails.length ? (
        <>
          <Notification
            iconColor="#ffb302"
            text={
              removedTechnicalDetails.map((val) => val).join("and") +
              " is removed your from product’s technical details as it’s no longer supported in platform."
            }
            bgColor="bg-light-warning"
          />
        </>
      ) : (
        <></>
      )}
      <div className="p-5">
        <Row className="mb-5">
          <Col sm>
            <h1 className="fs-22 fw-bolder">
              Edit {generalData.combinations[0].title.replace(/\s*\)\s*/g, ")")}
            </h1>
          </Col>
        </Row>
        {!fetchLoader ? (
          <Row>
            <Col lg={12}>
              <div className="border border-r10px px-lg-9 px-6 mb-8">
                <Row className="align-items-center">
                  <Col sm>
                    <div className="d-flex flex-md-row h-lg-70px h-md-60px">
                      <ul className="nav nav-stretch nav-line-tabs nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-18 fw-600">
                        {createTabs()}
                      </ul>
                    </div>
                  </Col>
                  {currentTab.value === 3 ? (
                    <Col sm={"auto"}>
                      <Button
                        variant=""
                        type="button"
                        className="btn btn-flush"
                        onClick={() => setProductGuidelinesModalShow(true)}
                      >
                        <span className="fs-18 fw-600 text-primary">
                          View image guideline
                        </span>
                      </Button>
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </div>
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active">
                  <>{currentTab.content}</>
                  <div className="d-flex justify-content-end mt-8">
                    {currentTab.value === 0 ? (
                      <></>
                    ) : loading ? (
                      <></>
                    ) : (
                      <div>
                        <Button
                          type="button"
                          className="uw-btn uw-btn-light uw-btn-lg btn btn-lg btn-light btnPrev btn-active-light-primary"
                          onClick={() => {
                            handlePreviousSelectTab(
                              tab[
                                tab.findIndex(
                                  (val: any) => val.value === currentTab.value
                                ) - 1
                              ]
                            );
                          }}
                          // disabled={loading}
                        >
                          Previous
                        </Button>
                      </div>
                    )}
                    <div>
                      <Button
                        type="button"
                        className={clsx(
                          loading ? "uw-btn uw-btn-lg btn btn-lg btnNext" : "uw-btn uw-btn-lg btn btn-lg"
                        )}
                        onClick={() => {
                          currentTab.value !== 3
                            ? handleSelectTab(
                                tab[
                                  tab.findIndex(
                                    (val: any) => val.value === currentTab.value
                                  ) + 1
                                ]
                              )
                            : handleSubmit();
                        }}
                        disabled={loading}
                      >
                        {!loading && (
                          <span className="indicator-label">
                            {currentTab.value === 3 ? "Finish" : "Next"}
                          </span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress fs-16 fw-bold"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <Loader loading={fetchLoader} />
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default EditProduct;
